import { ChangeSelectedSlotOptions } from 'store/booking-flow/types';
import { createAction } from 'typesafe-actions';

export const changeSelectedSlot = createAction('CHANGE_SELECTED_SLOT')<ChangeSelectedSlotOptions>();

export const resetSelectedSlot = createAction('RESET_SELECTED_SLOT')();
